import simpleFetch from "../../../../utils/simpleFetch";

class DataApi {
  static getTaxes(model, offset, limit, q, sortBy, filters, headers) {
    let query = { limit, offset, q, sortBy: sortBy.join(",") };
    if (filters) {
      query.filters = filters.join(";");
    }
    return simpleFetch("get", model.path, { query, headers });
  }

  static updateTaxes(model, body, headers) {
    return simpleFetch("put", model.path, { body, headers });
  }
}

export default DataApi;



// WEBPACK FOOTER //
// ./src/components/dashboard/sales-taxes/salesTaxesApi.js